module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-view has-header"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('form', {
    attrs: {
      "id": "search_form",
      "onsubmit": "return false"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim.lazy",
      value: (_vm.queryStr),
      expression: "queryStr",
      modifiers: {
        "trim": true,
        "lazy": true
      }
    }],
    attrs: {
      "type": "text",
      "name": "query",
      "placeholder": "搜索 书 / 影 / 音 / 标签"
    },
    domProps: {
      "value": (_vm.queryStr)
    },
    on: {
      "change": function($event) {
        _vm.queryStr = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        _vm.query()
      }
    }
  }, [_vm._v("搜索")])])]), _vm._v(" "), (_vm.queryStr) ? _c('div', {
    staticClass: "search-res"
  }, [_c('group', {
    attrs: {
      "title": "影视",
      "items": _vm.queryRes_movie
    }
  }, [_c('a', {
    staticClass: "list-link",
    attrs: {
      "href": "#"
    },
    slot: "more"
  }, [_vm._v("查看更多影视结果")])]), _vm._v(" "), _c('group', {
    attrs: {
      "title": "图书",
      "items": _vm.queryRes_movie
    }
  }, [_c('a', {
    staticClass: "list-link",
    attrs: {
      "href": "#"
    },
    slot: "more"
  }, [_vm._v("查看更多图书结果")])]), _vm._v(" "), _c('group', {
    attrs: {
      "title": "音乐",
      "items": _vm.queryRes_movie
    }
  }, [_c('a', {
    staticClass: "list-link",
    attrs: {
      "href": "#"
    },
    slot: "more"
  }, [_vm._v("查看更多音乐结果")])])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f499176"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/SearchView.vue
// module id = 202
// module chunks = 0